export const AGENT_STATUS = {
	APPROVED: 'approved',
	PENDING: 'pending',
	REJECTED: 'rejected',
	PURCHASED: 'purchased',
	ACTIVE: 'ACTIVE',
	PENDINGVERIFICATION: 'PENDNEW',
	AUTOCANCELLED: 'AUTOCXL',
};

export const TOP_FUNDS_CATEGORY = {
	ELSS: 'Tax Saving Equity'
};
export const INDIVIDUAL_TAX_STATUS = '01';

export const TAX_STATUS_OBJ: Record<string, string> = {
	'01': 'Individual',
	'02': 'Minor',
	'03': 'HUF',
	'04': 'Company',
	'05': 'AOP',
	'06': 'Partnership Firm',
	'08': 'Trust',
	'10': 'Others',
	'11': 'NRI Others',
	'12': 'DFI',
	'13': 'Sole Propritorship',
	'21': 'NRE',
	'23': 'FII',
	'24': 'NRO',
	'47': 'LLP',
	'52': 'Private Limited Company',
	'70': 'Person of Indian Origin',
	'76': 'Seafarer NRE', 
	'77':'Seafarer NRO', 
};
export const API_CATCH_MESSAGE = "Something went wrong. Please try again later";

//nominee relationship
export const relationshipMap: Record<string, string> = {
    "01": "Aunt",
    "02": "Brother-in-Law",
    "03": "Brother",
    "04": "Daughter",
    "05": "Daughter-in-Law",
    "06": "Father",
    "07": "Father-in-Law",
    "08": "Grand Daughter",
    "09": "Grand Father",
    "10": "Grand Mother",
    "11": "Grand Son",
    "12": "Mother-in-Law",
    "13": "Mother",
    "14": "Nephew",
    "15": "Niece",
    "16": "Sister",
    "17": "Sister-in-Law",
    "18": "Son",
    "19": "Son-in-Law",
    "20": "Spouse",
    "21": "Uncle",
    "22": "Others"
};
